import React from 'react';
import { Typography, Box, Container, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

const RegistrationInfo: React.FC = () => {
	return (
		<Container maxWidth='md'>
			<Box my={2} sx={{ position: 'relative' }}>
				<Typography variant='h6' gutterBottom>
					Let&apos;s Get Started
				</Typography>
				<Typography variant='body1' gutterBottom>
					Before you dive in, here&apos;s a quick overview of how to get started:
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>
							<EmailIcon color='primary' fontSize='large' />
						</ListItemIcon>
						<ListItemText primary='Enter your email to begin the registration process.' />
					</ListItem>
					<ListItem>
						<ListItemIcon>
							<SendIcon color='primary' fontSize='large' />
						</ListItemIcon>
						<ListItemText primary="We'll send you an email asking you to verify your email address." />
					</ListItem>
					<ListItem>
						<ListItemIcon>
							<QuestionAnswerIcon color='primary' fontSize='large' />
						</ListItemIcon>
						<ListItemText primary='Follow the secure link in our email to create your account. You will need to log in and answer a few policy-related security questions before we get started.' />
					</ListItem>
				</List>
			</Box>
		</Container>
	);
};

export default RegistrationInfo;
